import React from 'react';
import { motion } from 'framer-motion';
const stats = [{
  value: '2.4M+',
  label: 'Threats Neutralized'
}, {
  value: '99.97%',
  label: 'Uptime SLA'
}, {
  value: '< 8min',
  label: 'Mean Response Time'
}, {
  value: '340+',
  label: 'Enterprise Clients'
}];
export function StatsSection() {
  return <section className="py-20 bg-brand-dark relative overflow-hidden" data-id="element-203">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-4xl h-64 bg-brand-steel/10 blur-[100px] rounded-full pointer-events-none" data-id="element-204" />

      <div className="container mx-auto px-6 relative z-10" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-darker border border-brand-steel/30 rounded-2xl p-8 md:p-12 shadow-[0_0_40px_rgba(74,144,217,0.1)]" data-id="element-206">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 divide-x-0 md:divide-x divide-brand-border" data-id="element-207">
            {stats.map((stat, index) => <div key={index} className="text-center px-4" data-id="element-208">
                <motion.div initial={{
              scale: 0.5,
              opacity: 0
            }} whileInView={{
              scale: 1,
              opacity: 1
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.1,
              type: 'spring',
              stiffness: 100
            }} className="text-3xl md:text-5xl font-mono font-bold text-white mb-2 drop-shadow-[0_0_10px_rgba(74,144,217,0.5)]" data-id="element-209">
                  {stat.value}
                </motion.div>
                <div className="text-sm font-mono text-brand-cyan uppercase tracking-wider" data-id="element-210">
                  {stat.label}
                </div>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}